module.exports = __webpack_public_path__ + "img/header-logo.c4b87ff4.png";